<template>
  <div>
    <vs-card>
      <b-row class="justify-content-md-start">
        <b-col cols="3">
          <b-form-group label-for="item-name">
            <b-form-input v-model="arananDeger" id="smallInput" placeholder="Ara.." @keyup.enter="getReturnList"
              size="sm" />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="auto" style="padding-left: 0px !important;">
          <b-button style="background-color: #7367F0; border-color:white;" size="sm" v-on:click="getReturnList()">
            <Icon icon="material-symbols:search-rounded" width="20" height="20" />
          </b-button></b-col>
        <b-col cols="12" md="auto" style="padding-left: 0px !important;">
          <b-button style="background-color: #28C76F; border-color:white;" size="sm" v-on:click="addReturnList()">
            <Icon icon="material-symbols:add-ad-outline" width="20" height="20" /> Yeni Ekle
          </b-button></b-col>
      </b-row>
    </vs-card>
    <vs-card>
      <ag-grid-vue style="width: 100%; height: 400px; margin-top: 25px" class="ag-theme-alpine"
        :suppressRowClickSelection="true" :defaultColDef="defaultColDef" :columnDefs="columnDefs" :rowData="iadeler"
        :localeText="localeText" @grid-ready="onGridReady" @first-data-rendered="onFirstDataRendered"
        :rowSelection="rowSelection" :rowClassRules="rowClassRules">
      </ag-grid-vue>


    </vs-card>
  </div>
</template>
<script>

import { Icon } from "@iconify/vue2";
import state from "../../store/state";
import Store from "../../store/store";
import moment from "moment";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import IslemIadeCellRenderer from "./CellRenderers/IslemIadeCellRenderer.vue"
import TextGorunumCellRenderer from "./CellRenderers/TextGorunumCellRenderer.vue"

export default {
  data() {
    return {
      rowClassRules: null,
      rowdata: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      selected: "",
      arananDeger: "",
      iadeler: null,
      localeText: null,
      rowSelection: null,
      rowdata: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
    }
  },
  components: {
    TextGorunumCellRenderer,
    IslemIadeCellRenderer,
    Icon,
    AgGridVue
  },
  methods: {
    approveReturn(item) {
      var vm = this;

      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        program: item.program,
        orderNumber: item.orderNumber,
      };
      soap.createClient(url, function (err, client) {
        client.ManuelIadeSiparisOnay(args, function (err, result) {
          if (result.ManuelIadeSiparisOnayResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            let veriler = JSON.parse(result.ManuelIadeSiparisOnayResult); 
            if (veriler.error == "Yes") {
              vs.notify({
                text: "Başarısız",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            } else {
              vm.getReturnList();
              vs.notify({
                text: "Başarılı. İade kaydı yapıldı",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
            }

          } catch (error) {
            console.log(error)
            vs.notify({
              text: "Başarısız",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY");
    },
    addReturnList() {
      let routeData = this.$router.resolve({
        name: "iadeekle",
      });
      window.open(routeData.href, "_blank");
    },
    getReturnList() {
      var vm = this;

      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        program: "",
        orderNumber: ""
      }; 
      soap.createClient(url, function (err, client) {
        client.ManuelIadeSiparisLiastele(args, function (err, result) {
          if (result.ManuelIadeSiparisLiasteleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            let veriler = JSON.parse(result.ManuelIadeSiparisLiasteleResult); 
            vm.iadeler = veriler.jsonData
          } catch (error) {
            console.log(error)
            vs.notify({
              text: "Başarısız",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;

    },
  },
  created() {
    this.getReturnList();
    this.rowSelection = 'single';
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
    this.rowClassRules = {
      'bg-success': (params) => { 
        var numSickDays = params.data.kabul;
        return numSickDays == "1";
      },
    };
  },
  beforeMount() {
    this.columnDefs = [

      {
        headerName: "Sipariş Numarası",
        field: "orderNumber",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Program",
        field: "program",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        width: 100,
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },

      {
        headerName: "Ad",
        field: "customerFirstName",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: 'İade Tarihi',
        field: 'iadeSiparisTarihi',
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }, 
        valueFormatter: (params) => this.parseDate(params.data.iadeSiparisTarihi)
      },
      {
        headerName: 'İade Nedeni',
        field: 'iadeNedeni',
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: 'İade Aciklama',
        field: 'iadeAciklama',
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },

      {
        headerName: 'Toplam Tutar',
        field: 'totalPrice',
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: (params) =>
          new Intl.NumberFormat("tr-TR",
            { style: "currency", currency: "TRY" }).format(parseFloat(params.data.totalPrice.toString().replace(',',
              '.')))
      },
      {
        cellRenderer: "IslemIadeCellRenderer",
      },
    ];
  },
  mounted() {
    this.$root.$on("approveReturn", params => {
      this.approveReturn(params);
    });
  },
  beforeDestroy() {
    this.$root.$off("approveReturn");
  },
}
</script>
<style lang="scss">
.bg-success {
  background-color: #acfcd0 !important;

}

.bg-danger {
  background-color: #F8CBCC !important;

}
</style>